module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-upload', {
    ref: "upload",
    attrs: {
      "action": "none",
      "list-type": "picture-card",
      "multiple": _vm.multiple,
      "accept": _vm.accept,
      "disabled": _vm.disabled,
      "file-list": _vm.postData,
      "on-preview": _vm.onPreview,
      "on-remove": _vm.onRemove,
      "on-success": _vm.onSuccess,
      "on-error": _vm.onError,
      "on-progress": _vm.onProgress,
      "on-change": _vm.onChange,
      "on-exceed": _vm.onExceed,
      "before-upload": _vm.beforeUpload,
      "http-request": _vm.uploadFile,
      "limit": _vm.limit
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5cb1957a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/picker/PicUploader.vue
// module id = 1499
// module chunks = 0